module.exports = __webpack_public_path__ + "img/4.3623a204.jpg";